import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Children, Component } from 'react';
import classNames from 'classnames';
import devLogger from 'react-utils/devLogger';
const USE_CLASSES = {
  default: '',
  dark: 'private-tool-bar--dark',
  'filter-bar': 'private-tool-bar--with-filters',
  tabs: 'private-tool-bar--with-tabs'
};
/** @internal */

export default class UIToolBar extends Component {
  render() {
    // `title` blacklisted here since `UIAbstractPageTemplate` expects one in CustomRenderer
    const _this$props = this.props,
          {
      children,
      className,
      use
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "title", "use"]);

    const childCount = Children.count(children);

    if (process.env.NODE_ENV !== 'production') {
      if (use === 'filter-bar' && childCount > 2) {
        devLogger.warn({
          message: 'UIToolBar: More than 2 UIToolBarGroup items in a filter-bar is not recommended',
          key: 'UIToolBar: too many children for filter-bar'
        });
      }

      if (childCount > 3) {
        devLogger.warn({
          message: 'UIToolBar: More than 3 UIToolBarGroup items are not recommended',
          key: 'UIToolBar: too many children in toolbar'
        });
      }
    }

    return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
      className: classNames('private-tool-bar', className, use && USE_CLASSES[use]),
      role: "group",
      children: /*#__PURE__*/_jsx("div", {
        className: "private-tool-bar__inner",
        children: children
      })
    }));
  }

}
const propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  use: PropTypes.oneOf(Object.keys(USE_CLASSES))
};
UIToolBar.propTypes = propTypes;
UIToolBar.displayName = 'UIToolBar';